import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Slots from './components/Slots/Slots';
import Auth from './components/Auth/Auth';
import MySlots from './components/Slots/MySlots';
import Anketa from './components/Anketa/Anketa';
import './App.css';
import Navigation from './components/Menu/Navigation';
import Profile from './components/Profile/Profile';
import Admin from './components/Admin/Admin';
import { useDispatch } from 'react-redux';
import { setUser, setUserEmail } from './components/Auth/authSlice';

const AppContent = () => {
  const location = useLocation();
  
  const hideNavOnPaths = ['/auth', '/admin'];

  return (
    <>
      {!hideNavOnPaths.includes(location.pathname) && <Navigation />}
      <Routes>
        <Route path="/auth" element={<Auth />} />
        <Route path="/slots" element={<Slots />} />
        <Route path="/myslots" element={<MySlots />} />
        <Route path="/anketa" element={<Anketa />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="*" element={<Navigate to="/auth" replace />} />
      </Routes>
    </>
  );
};



function App() {
  const dispatch = useDispatch();
  useEffect(() => {
    const storedUser = localStorage.getItem('authUser');
    if (storedUser) {
      console.log('storedUser', storedUser)
      dispatch(setUser(JSON.parse(storedUser)));
      dispatch(setUserEmail(storedUser.email))
      // не обязательно делать navigate здесь — зависит от маршрута
    }
  }, []);
  return (
    <Router>
      <div className="App">
        <AppContent />
      </div>
    </Router>
  );
}

export default App;
